<section class="student-detail-wrap">
  <div class="wrap-lg">
    <div class="student-inner">
      <div class="nav-sec">
        <div class="back-nav" (click)="gotoHome()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 6L9 12L15 18" stroke="#1A204B" stroke-width="1.75" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span class="nav-name" >Back</span>
        </div>
      </div>
      <div class="page-head">
        <div class="head-left">
          <div class="page-title">Great! Please Enter <span class="wrap-text">Student Details</span></div>
        </div>
      </div>
      <div class="box-wrap">
        <form class="cus-row" [formGroup]="formDetails">
          <div class="col-3 form-group">
            <label class="form-label">Enter the student’s name</label>
            <input class="cus-input" type="text" placeholder="Enter Name" formControlName="candidateName" appRestrictSpecialChars/>
          </div>
          <div class="col-3 form-group" *ngIf="isSF">
            <label class="form-label">School board</label>
            <div class="cus-dropdown" (click)="openDrop('boardName_drop')">
              <input class="cus-input" type="text"  placeholder="Select board" formControlName ='boardType' readonly />
              <div id="boardName_drop" class="drop-content"  *ngIf="boardTypeList">
                  <div class="drop-item" *ngFor="let board of boardTypeList" (click)="getBoardType(board.type)">{{board.type}}</div>
               
              </div>
            </div>
          </div>
          
          <div class="col-3 form-group">
            <label class="form-label">Date of birth of the student</label>
            <!-- <input class="cus-input" type="text" placeholder="dd/mm/yyyy" formControlName="candidateDOB"  appDateFormatDirective [formCtrl]="formDetails.controls['candidateDOB']"/> -->
            <app-date [control]="formDetails.controls['candidateDOB']"></app-date>
            <div class="cus-input error" *ngIf="formDetails.controls['candidateDOB'].dirty && formDetails.controls['candidateDOB'].errors && formDetails.controls['candidateDOB'].errors['invalidDate']">Please enter valid date(dd/mm/yyyy).</div>
            <div class="cus-input error" *ngIf="formDetails.controls['candidateDOB'].dirty && formDetails.controls['candidateDOB'].errors && formDetails.controls['candidateDOB'].errors['dateGreaterThanToday']">DOB cannot be greater than today.</div>

            <!-- <p-calendar [maxDate]="today" formControlName="candidateDOB" placeholder="Enter DOB"  [readonlyInput]="true"></p-calendar> -->
          </div>
          <div class="col-3 form-group" *ngIf="isSF">
            <label class="form-label">Student’s standard</label>
            <div class="cus-dropdown" (click)="formDetails.controls['boardType'].value ? openDrop('standard') : '' ">
              <input class="cus-input" type="text"  placeholder="Select standard" formControlName ='standards' readonly />
              <div id="standard" class="drop-content" *ngIf="standardList">
                  <div class="drop-item" *ngFor="let standard of standardList" (click)="setStandard(standard)">{{standard.courseName}}</div>
               
              </div>
            </div>
          </div>
          <!-- <div class="col-3 form-group">
            <label class="form-label">Student’s gender</label>
            <div class="box-select">
              <div class="select-item" *ngFor="let gender of genderType"
                (click)="formDetails.controls['genderType'].setValue(gender.value)"
                [ngClass]="{'selected': formDetails.controls['genderType'].value === gender.value}">{{gender.label}}
              </div>
            </div>
          </div> -->
          <div class="col-3 form-group" >
            <label class="form-label">Student’s gender</label>
            <div class="box-select">
              <div class="cus-dropdown gender_drop" (click)="openDrop('gender_drop')" >
                <input class="cus-input" type="text" readOnly  [value]="getGenderLabel()"    placeholder="Select Gender" />
                <div id="gender_drop" #options class="drop-content" >
                  <div  *ngFor="let gender of genderType"  class="drop-item"  [ngClass]="{'selected': formDetails.controls['genderType'].value === gender.value}" (click)="formDetails.controls['genderType'].setValue(gender.value)"  >{{gender.label}}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-3 form-group" *ngIf="isAdult && !isSF && !moratorium && !util.loanDetails.isCapacitaFlow">
            <label class="form-label">Select the student’s employment status</label>
            <div class="box-select">
              <div class="select-item" (click)="formDetails.controls['status'].setValue(status.id)"
                [ngClass]="{'selected': formDetails.controls['status'].value === status.id}"
                *ngFor="let status of empStatus">{{status.status | titlecase}}</div>
            </div>
          </div> -->
          <div class="col-3 form-group" *ngIf="isAdult && !isSF && !moratorium && !util.loanDetails.isCapacitaFlow">
            <label class="form-label">Select the student’s employment status</label>
            <div class="box-select">
              <div class="cus-dropdown emp_drop" (click)="openDrop('emp_drop')" >
                <input class="cus-input" type="text" readOnly  [value]="getEmpLabel() | titlecase"    placeholder="Select employment status" />
                <div id="emp_drop" #options class="drop-content" >
                  <div  *ngFor="let status of empStatus"  class="drop-item"  [ngClass]="{'selected': formDetails.controls['status'].value === status.id}" (click)="formDetails.controls['status'].setValue(status.id)"  >{{status.status | titlecase}}</div>
                </div>
              </div>
            </div>
          </div>

          
          <div class="col-6 form-group" *ngIf="isAdult && formDetails.value.status !== '3' && !isSF && !moratorium && false"> <!-- false add in sponsor temp hide purpose , remove false its working good -->
            <label class="form-label">Would you like to add a sponsor who will be the repayer?</label>
            <div class="box-select">
              <div class="select-item" (click)="status.value === repayer[0].value? sponsorConfirm() :formDetails.controls['repayer'].setValue(status.value)"
                [ngClass]="{'selected': formDetails.controls['repayer'].value === status.value}"
                *ngFor="let status of repayer">{{status.label}}</div>
            </div>
          </div>
          <ng-container *ngIf="moratorium">
            <div class="col-3 form-group">
              <label class="form-label"
                >Employment status of the candidate</label
              >
              <input
                class="cus-input"
                type="text"
                placeholder="Enter employment status"
                formControlName="employmentststusofcandidate"
                appRestrictSpecialChars
              />
            </div>
            <div class="col-3 form-group">
              <label class="form-label">Enter the name of the employer</label>
              <input
                class="cus-input"
                type="text"
                placeholder="Enter name of the employer"
                formControlName="employerName"
                appRestrictSpecialChars
              />
            </div>
            <div class="col-3 form-group">
              <label class="form-label">Enter your net income per month</label>
              <input
                class="cus-input"
                type="text"
                placeholder="Enter your net income per month"
                formControlName="monthlyIncome"
                (keydown)="onlyNumber($event)"
                maxlength="14"
                decimal-mask
              />
            </div>
            <div class="col-3">
              <div class="upload-offers " [class.completed]="fileUploaded">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"  *ngIf="!fileUploaded">
                  <path d="M25.1943 6.43966C25.3094 6.63699 25.0981 6.85796 24.8778 6.79738C24.8113 6.77908 24.7448 6.76246 24.6782 6.74734C24.1038 6.57623 23.4682 6.49068 22.8205 6.49068H18.6064C18.5278 6.49068 18.4538 6.4537 18.4066 6.39086L16.8927 4.37623C16.8513 4.31761 16.8089 4.25996 16.7656 4.20301C16.6356 4.03207 16.7522 3.77734 16.967 3.77734H20.5471C22.5288 3.77734 24.2653 4.84635 25.1943 6.43966Z" fill="#10D7EE"/>
                  <path d="M25.9485 9.32623C25.4229 8.94734 24.824 8.66623 24.1762 8.50734C23.7362 8.38512 23.284 8.32401 22.8196 8.32401H18.2729C17.564 8.32401 17.5151 8.2629 17.1362 7.76179L15.4251 5.48845C14.6307 4.42512 14.0073 3.77734 12.0151 3.77734H9.17957C6.19734 3.77734 3.77734 6.19734 3.77734 9.17957V22.8196C3.77734 25.8018 6.19734 28.2218 9.17957 28.2218H22.8196C25.8018 28.2218 28.2218 25.8018 28.2218 22.8196V13.7262C28.2218 11.9051 27.3296 10.304 25.9485 9.32623ZM18.9207 21.304H13.0662C12.5896 21.304 12.2229 20.9251 12.2229 20.4485C12.2229 19.984 12.5896 19.5929 13.0662 19.5929H18.9207C19.3973 19.5929 19.7762 19.984 19.7762 20.4485C19.7762 20.9251 19.3973 21.304 18.9207 21.304Z" fill="#17151C"/>
                  <rect x="12" y="19.333" width="8" height="2" rx="1" fill="#10D7EE"/>
                  </svg>
                  
                <img
                  src="assets/images/pdf.png"
                  width="47px"
                  *ngIf="fileUploaded"
                />
                <div class="offer-detail">
                  <div class="offer-title">{{ fileNameObj.title }}</div>
                  <div class="offer-info">{{ fileNameObj.info }}</div>
                  <div
                    class="offer-action"
                    (click)="offer.click()"
                    *ngIf="!fileUploaded"
                  >
                    Browse file
                  </div>
                  <input
                    type="file"
                    #offer
                    accept="application/pdf"
                    (change)="uploadDoc($event)"
                  />
                </div>
                <div class="offer-close" *ngIf="fileUploaded">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="closeFile(offer)" pTooltip="Close">
                    <circle cx="12" cy="12" r="12" fill="white"/>
                    <path d="M8 16.0001L16.0001 8" stroke="#17151C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M16.0001 16.0001L8 8" stroke="#17151C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    
                </div>
              </div>
            </div>
          </ng-container>
        </form>
        <div class="page-action">
          <button class="btn-primary" [disabled]="!isValidForm"  (click)="submit()">Continue</button>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Custom tenure Select Popup-->
<p-dialog [(visible)]="sponsorConfirmPopup" [modal]="true" styleClass="cus-dialog-sm cus-dialog confirm-dialog"
  [draggable]="false" [resizable]="false">
  <div class="confirm-content">
    <div class="dialog-title">Who is a Sponsor?</div>
    <div class="confirm-info">A Sponsor is the main applicant<span class="wrap-text"> who takes the loan journey and
        they will</span> be responsible for repaying the loan</div>
    <div class="confirm-action">
      <button class="btn-primary" (click)="sponsorConfirmPopup = false; formDetails.controls['repayer'].setValue(repayer[0].value);  submit()">Yes, Proceed</button>
    </div>
  </div>
</p-dialog>
<p-dialog [(visible)]="guardianFlowPopup" (onHide)="util.navigationHandler();" [modal]="true" styleClass="cus-dialog-lg cus-dialog dark-dialog"
  [draggable]="false" [resizable]="false">
  <!-- If you dont want dialod close button then add no-exit class in above -->
  <!-- Guardian Confirm -->
  <div *ngIf="isParentFlow" class="dark-content guardian-dialog">
    <div class="dark-inner">
      <div class="gradient-line"></div>
      <div class="dark-left">
        <img src="assets/images/dialog/guardian_info.png" alt="Guardian Image" />
      </div>
      <div class="dark-right">
        <div class="dark-inn-title"><span class="highlight">Parent/Guardian</span> <span class="wrap-text">will be the
            Applicant</span></div>
        <div class="dark-inn-info">who will be filling the application, they <span class="wrap-text">will assume
            responsibility for</span> repaying the loan</div>
      </div>
    </div>
  </div>
  <div *ngIf="isStudentFlow" class="dark-content guardian-dialog">
    <div class="dark-inner">
      <div class="gradient-line"></div>
      <div class="dark-left">
        <img src="assets/images/student_icon.png" alt="Guardian Image" />
      </div>
      <div class="dark-right">
        <div class="dark-inn-title"><span class="highlight">Student</span> <span class="wrap-text">will be the
            Applicant</span></div>
        <div class="dark-inn-info">Since the student is a major, they<span class="wrap-text">will be included in the loan application as</span> the applicant.</div>
      </div>
    </div>
  </div>
</p-dialog>
